/**
 *
 * @param {object} sidePanel - the redux sidePanel object
 * @param {redux action creator} revertSidePanel - the redux action creator
 * @param {redux action creator} closeSidePanel - the redux action creator
 */
export const determineBack = (sidePanel, revertSidePanel, closeSidePanel) => {
  const { backBehavior, breadcrumbs } = sidePanel;
  if (backBehavior) {
    if (backBehavior === 'revertSidePanel') {
      revertSidePanel();
    } else {
      closeSidePanel();
    }
  } else if (breadcrumbs.length > 0) {
    revertSidePanel();
  } else {
    closeSidePanel();
  }
};
